import { PaymentMethod } from "../models/PaymentMethod";
import { PaymentMethodApi } from "./apiServices/PaymentMethodApi";
import { NetworkErrorService } from "./NetworkError.service";
import { UserStore } from "./stores/UserStore";
import { take } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * Created by req85103 on 1/24/17.
 */
@Injectable({ providedIn: "root" })
export class WalletService {
    paymentMethods: PaymentMethod[];

    constructor(@Inject(PaymentMethodApi) private paymentMethodApi: PaymentMethodApi,
                @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
                @Inject(UserStore) private userStore: UserStore) {
    }

    getPaymentMethods() {
        this.getPaymentMethodsWS().pipe(take(1)).subscribe((resp) => {
            return resp;
        })
    }

    hasPaymentMethods() {
        return new Observable(observer => {

            this.getPaymentMethodsWS().pipe(take(1)).subscribe((resp: PaymentMethod[]) => {
                if (resp && resp.length > 0) {
                    observer.next(true);
                } else {
                    observer.next(false);
                }
            }, (err) => {
                observer.next(err);
            });

        });
    }

    private getPaymentMethodsWS() {

        return new Observable(observer => {

            this.paymentMethodApi.homeownersIdPaymentMethodsGet(this.userStore.getHoaHomeownerId())
                .pipe(take(1)).subscribe((resp) => {
                    if (resp && resp.length > 0) {
                        observer.next(resp);
                    } else {
                        observer.next([]);
                    }
                }, (err) => {
                    this.networkErrorService.handleNetworkError(err, true)
                        .pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.getPaymentMethodsWS();
                            }
                            observer.error();
                        });
                });

        })
    }
}
